module.exports = __webpack_public_path__ + "a5e7145788241c948acbd38640387d8e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-details.png
// module id = 2960
// module chunks = 0